export default {
    "/": {
        "title": "Taoify - 跨境電商獨立站建站平台 | 中國貨，賣全球",
        "desc": "Taoify 把建站、翻譯、上架、物流、收款、行銷整合到一個後台：18 位 AI 員工幫你工作，20 種語言開店，中國貨賣到全世界。"
    },
    "/feature": {
        "title": "功能 · 開店要用的東西，這頁全有 · Taoify",
        "desc": "建站、翻譯、上架、發貨、收款、拉客戶——Taoify 把跨境賣貨需要的 15 個模組放在一個後台，不用再去外面拼七八個工具。"
    },
    "/ai-staff": {
        "title": "AI 員工 · 18 位 AI 員工，最忙的是拉流量那幾位 · Taoify",
        "desc": "18 位 AI 員工中，增長組的 5 位專門解決「沒人來」：12 項商店體檢、30 天行銷方案、一件商品改寫成 9 個渠道的成品、自動行銷郵件把買過的人叫回來。"
    },
    "/logistics": {
        "title": "跨境物流 · 從你手中到客戶手中 · Taoify",
        "desc": "頭程、清關、幹線、末端派送，三條路線按貨物和時效選擇。雲途、燕文、4PX 已接通，面單、軌跡、異常處理都在同一個後台。"
    },
    "/payment": {
        "title": "收款與結算 · 客戶怎麼方便就怎麼付 · Taoify",
        "desc": "PayPal、Stripe、信用卡、支付寶接上即用。外幣收進來，人民幣提出來，T+7 結算，費率和到帳時間寫在明面上。"
    },
    "/pricing": {
        "title": "價格 · 訂閱套餐 + 階梯佣金 · Taoify",
        "desc": "商店按訂閱套餐收費：基礎版 $15/月、標準版 $29/月、旗艦版 $59/月，季付年付更省。交易佣金按月成交額階梯，最低 3%。"
    },
    "/cases": {
        "title": "賣家案例 · 他們也在做同一件事 · Taoify",
        "desc": "義烏飾品、深圳 3C、廣州服裝，還有德國、美國、法國的賣家——六個人，六種起點，同一套做法。"
    },
    "/sign-up": {
        "title": "店鋪開通 - Taoify 免費註冊開店",
        "desc": "10 分鐘搭建品牌獨立站，零代碼、訂閱套餐全功能試用，全鏈路閉環。立即註冊 Taoify，開啟跨境電商之旅。"
    },
    "/for-china-sellers": {
        "title": "給中國賣家 · 你只管選品和定價，其餘我們辦 · Taoify",
        "desc": "建站、翻譯、運費、打面單、答客戶——跨境賣貨中間這些麻煩事，平台替你做了。訂閱套餐 + 階梯佣金（低至 3%）。"
    },
    "/for-global-sellers": {
        "title": "給海外賣家：在中國的貨架上選品，在你自己的店裡賣 · Taoify",
        "desc": "不壓貨、不囤庫存：從中國供應鏈選品上架，客戶下單後由中國倉直發，你賺差價。BuyLink 還能把 1688、淘寶連結變成你的商品。"
    },
    "/template-index": {
        "title": "模板市場 - Taoify 專業網站主題模板",
        "desc": "適用於任何項目的專業主題網站模板，海量行業模板免費使用，根據需求自定義品牌形象和功能。"
    },
    "/question": {
        "title": "幫助中心 · 有問題，先在這裡找 · Taoify",
        "desc": "開店、裝修、上架、訂單物流、收款、行銷、帳號權限——常見問題按分類整理，找不到再提工單。"
    },
    "/about-us": {
        "title": "關於 Taoify · 我們在做什麼",
        "desc": "Taoify 是為跨境賣家提供的一體化建站平台：建站、翻譯、上架、物流、收款、行銷在一個後台完成。"
    },
    "/privacy-policy": {
        "title": "隱私政策 · Taoify",
        "desc": "Taoify 如何收集、使用、儲存和保護您的個人資訊，以及您對自己的資料所擁有的權利。"
    },
    "/terms-service": {
        "title": "服務條款 · Taoify",
        "desc": "使用 Taoify 平台服務的條款與條件：帳號、商店、訂單、結算與責任劃分。"
    },
    "/consumer-agreement": {
        "title": "退款政策 · Taoify",
        "desc": "Taoify 平台訂單的退貨與售後規則：申請條件、處理時限與到帳方式。"
    },
    "/user-agreement": {
        "title": "用戶協議 · Taoify",
        "desc": "註冊和使用 Taoify 前請先閱讀：帳號註冊、店鋪經營規範與平台服務說明。"
    }
}
